// import { theme } from '@jfa/sites/katharinaira'
const theme = require(`../../../../libs/sites/${process.env.GATSBY_SITENAME}/src/theme.json`)
export default theme
